import { memo } from 'react';
import type { CharStatus } from '../../types/typing';

interface CharacterCellProps {
  char: string;
  status: CharStatus;
}

/**
 * Single character in the typing display.
 *
 * All props are primitives — React.memo's shallow comparison is a true O(1) bailout.
 * Re-renders ONLY when status changes (1-2 cells per keystroke max).
 */
const CharacterCell = memo(function CharacterCell({
  char,
  status,
}: CharacterCellProps) {
  const displayChar = char === ' ' ? '\u00A0' : char === '\n' ? '↵' : char;

  return (
    <span className={`char char--${status}`} aria-hidden="true">
      {displayChar}
    </span>
  );
});

export default CharacterCell;
